// Role-based, grouped navigation config for admin sidebar.
import {
    LayoutDashboard, ShoppingBag, Package, Layers, Tag, Boxes, Users, UserCheck,
    Truck, Settings, ClipboardList, HeartHandshake, Percent, Building2,
    Ruler, Handshake, Palette, DatabaseBackup, BarChart3,
} from 'lucide-react';

export const NAV_GROUPS = [
    {
        key: 'top', label: null,           // ungrouped, rendered first
        items: [
            { to: '/dharmikdashboard', label: 'Dashboard', icon: LayoutDashboard, roles: ['super_admin', 'sales', 'inventory_manager'], testid: 'nav-dashboard' },
        ],
    },
    {
        key: 'orders', label: 'Order Manager',
        items: [
            { to: '/dharmikdashboard/orders', label: 'Orders', icon: ShoppingBag, roles: ['super_admin', 'sales', 'inventory_manager'], testid: 'nav-orders' },
            { to: '/dharmikdashboard/customers', label: 'Customers', icon: Users, roles: ['super_admin', 'sales', 'inventory_manager'], testid: 'nav-customers' },
            { to: '/dharmikdashboard/wholesale', label: 'Wholesale Approvals', icon: UserCheck, roles: ['super_admin', 'sales'], testid: 'nav-wholesale' },
            { to: '/dharmikdashboard/service-enquiries', label: 'Service Enquiries', icon: HeartHandshake, roles: ['super_admin', 'sales'], testid: 'nav-service-enquiries' },
            { to: '/dharmikdashboard/crm', label: 'CRM', icon: ClipboardList, roles: ['super_admin', 'sales'], testid: 'nav-crm' },
        ],
    },
    {
        key: 'masters', label: 'Masters',
        items: [
            { to: '/dharmikdashboard/products', label: 'Products', icon: Package, roles: ['super_admin', 'inventory_manager', 'sales'], testid: 'nav-products' },
            { to: '/dharmikdashboard/categories', label: 'Categories', icon: Layers, roles: ['super_admin', 'inventory_manager'], testid: 'nav-categories' },
            { to: '/dharmikdashboard/brands', label: 'Brands', icon: Tag, roles: ['super_admin', 'inventory_manager'], testid: 'nav-brands' },
            { to: '/dharmikdashboard/suppliers', label: 'Suppliers', icon: Handshake, roles: ['super_admin', 'inventory_manager'], testid: 'nav-suppliers' },
            { to: '/dharmikdashboard/units', label: 'Units (UOM)', icon: Ruler, roles: ['super_admin', 'inventory_manager'], testid: 'nav-units' },
        ],
    },
    {
        key: 'settings', label: 'Settings',
        items: [
            { to: '/dharmikdashboard/tax-groups', label: 'Tax Groups (GST)', icon: Percent, roles: ['super_admin'], testid: 'nav-tax-groups' },
            { to: '/dharmikdashboard/shipping', label: 'Shipping Rates', icon: Truck, roles: ['super_admin'], testid: 'nav-shipping' },
            { to: '/dharmikdashboard/home-cms', label: 'Home Page CMS', icon: Palette, roles: ['super_admin'], testid: 'nav-home-cms' },
            { to: '/dharmikdashboard/business-settings', label: 'Business Settings', icon: Building2, roles: ['super_admin'], testid: 'nav-business-settings' },
            { to: '/dharmikdashboard/users', label: 'Admin Users', icon: Settings, roles: ['super_admin'], testid: 'nav-users' },
            { to: '/dharmikdashboard/system', label: 'System / Backup', icon: DatabaseBackup, roles: ['super_admin'], testid: 'nav-system' },
        ],
    },
    {
        key: 'reports', label: 'Reports',
        items: [
            { to: '/dharmikdashboard/inventory', label: 'Inventory', icon: Boxes, roles: ['super_admin', 'inventory_manager', 'sales'], testid: 'nav-inventory' },
            // more report pages can be added here later
        ],
    },
];

// Legacy flat list kept for any older imports
export const NAV_ITEMS = NAV_GROUPS.flatMap(g => g.items);

export function visibleNav(role) {
    return NAV_ITEMS.filter(i => !i.roles || i.roles.includes(role));
}

export function visibleGroups(role) {
    return NAV_GROUPS
        .map(g => ({ ...g, items: g.items.filter(i => !i.roles || i.roles.includes(role)) }))
        .filter(g => g.items.length > 0);
}
